module.exports = __webpack_public_path__ + "img/search.30d8ff10.svg";